import ATable from './a-table.vue'

export default ATable
